'use client';
import { SIZING_1 } from '@mnd-frontend/ui/shared/tokens';
import styled from 'styled-components';

const AlignSteppers = styled.div`
    display: inline-flex;
    gap: ${SIZING_1};
`;

const Dot = styled.div<{ $isActive: boolean }>`
    width: ${SIZING_1};
    height: ${SIZING_1};
    border-radius: 50%;
    background-color: ${props => (props.$isActive ? '#FF4473' : '#FFDCE5')};
`;

const Stepper = ({
  numOfSteps,
  activeStepIndex,
}: {
  numOfSteps: number;
  activeStepIndex: number;
}) => (
  <AlignSteppers>
    {Array.from({ length: numOfSteps }).map((_, index) => (
      <Dot key={index} $isActive={activeStepIndex === index} />
    ))}
  </AlignSteppers>
);

export default Stepper;
